const USERID = 'Meteor.userId';
const LOGINTOKEN = 'Meteor.loginToken';

export const MeteorLocalStorage = {
  USERID,
  LOGINTOKEN,
};
